import React, { Component } from 'react';
import './App.css';

import About from "./About";
import Catalog from "./catalog/Catalog";
import Product1 from "./Product1";
import Product6 from "./Product6";
import Events from "./Events";
import Submissions from "./Submissions";
import ContactPage from "./ContactPage";

import ThemeToggle from "./components/ThemeToggle";
import CartDrawer from "./components/CartDrawer";
import ConsentBanner from './components/ConsentBanner';

import { Helmet } from "react-helmet";
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';

import { Route, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faTwitterSquare } from "@fortawesome/free-brands-svg-icons";

import { openBag, initCart } from './redux/actions/bagActions';
import { handleAlertClose } from './redux/actions/alertActions';
import { connect } from 'react-redux';

const NAV = [
	{ to: '/catalog', label: 'Catalog' },
	{ to: '/submissions', label: 'Submissions' },
	{ to: '/events', label: 'Events' },
	{ to: '/contact', label: 'Contact' },
];

class App extends Component {
	constructor(props) {
		super(props);
		this.state = { mobileOpen: false };
		this.handleAlertClose = this.props.handleAlertClose.bind(this);
	}

	componentDidMount() {
		// Rehydrate the Shopify cart (if any) so the bag/count survive reloads.
		this.props.initCart();
	}

	setMobile(open) {
		this.setState({ mobileOpen: open });
	}

	render() {
		const { bagCount, isProgressOpen, openBag } = this.props;

		return (
			<div className="App">
				<ConsentBanner />

				<Helmet>
					<title>Newfangle Press</title>
					<meta name="google-site-verification" content="NGCtSxuSzrQED1Pm4oA36ZQnW5Q4U_5Cqidht9CYiB4" />
					<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
					<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
					<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
					<link rel="manifest" href="/site.webmanifest" />
				</Helmet>

				<Backdrop style={{ color: '#C2452E', zIndex: 1200 }} open={isProgressOpen}>
					<CircularProgress color="inherit" />
				</Backdrop>

				<header className="nf-masthead">
					<div className="nf-masthead-in">
						<NavLink className="nf-brand" to="/">
							<span className="nf-brand-name">Newfangle Press</span>
							<span className="nf-brand-tag">Independent · Cincinnati · Est. 2020</span>
						</NavLink>

						<nav className="nf-nav">
							{NAV.map((n) => (
								<NavLink key={n.to} to={n.to} activeClassName="active">
									{n.label}
								</NavLink>
							))}
						</nav>

						<div className="nf-actions">
							<ThemeToggle />
							<button
								type="button"
								className="nf-icon-btn nf-cart-btn"
								onClick={openBag}
								aria-label="Open bag"
							>
								<FontAwesomeIcon icon={faShoppingCart} />
								{bagCount > 0 && <span className="nf-cart-count">{bagCount}</span>}
							</button>
							<button
								type="button"
								className="nf-icon-btn nf-hamburger"
								onClick={() => this.setMobile(true)}
								aria-label="Menu"
							>
								<MenuIcon />
							</button>
						</div>
					</div>
				</header>

				<Drawer anchor="left" open={this.state.mobileOpen} onClose={() => this.setMobile(false)}>
					<nav className="nf-drawer-nav" onClick={() => this.setMobile(false)}>
						<NavLink to="/" exact activeClassName="active">Home</NavLink>
						{NAV.map((n) => (
							<NavLink key={n.to} to={n.to} activeClassName="active">
								{n.label}
							</NavLink>
						))}
					</nav>
				</Drawer>

				<Collapse in={this.props.isAlertOpen} style={{ position: 'fixed', zIndex: 200, width: '100%' }}>
					<Alert
						severity={this.props.alertSeverity}
						action={
							<IconButton aria-label="close" color="inherit" size="small" onClick={this.handleAlertClose}>
								<CloseIcon fontSize="inherit" />
							</IconButton>
						}
					>
						<AlertTitle>{this.props.alertTitle}</AlertTitle>
						{this.props.alertMessage}
					</Alert>
				</Collapse>

				<main className="nf-main">
					<Route exact path="/" component={About} />
					<Route exact path="/catalog" component={Catalog} />
					<Route exact path="/catalog/the-ingenue" component={Product1} />
					<Route exact path="/catalog/never-sleep-again" component={Product6} />
					<Route path="/submissions" component={Submissions} />
					<Route path="/events" component={Events} />
					<Route path="/contact" component={ContactPage} />
				</main>

				<footer className="nf-footer">
					<div className="nf-footer-in">
						<span className="nf-footer-name">Newfangle Press</span>
						<div className="nf-footer-social">
							<a href="https://facebook.com/newfanglepress" aria-label="Facebook">
								<FontAwesomeIcon icon={faFacebookSquare} />
							</a>
							<a href="https://twitter.com/NewfanglePress" aria-label="Twitter">
								<FontAwesomeIcon icon={faTwitterSquare} />
							</a>
						</div>
						<span className="nf-footer-copy">
							© 2020–{new Date().getFullYear()} Newfangle Media LLC · Cincinnati, Ohio · USA
						</span>
					</div>
				</footer>

				<CartDrawer />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	alertTitle: state.alert.alertTitle,
	alertSeverity: state.alert.alertSeverity,
	alertMessage: state.alert.alertMessage,
	isAlertOpen: state.alert.isAlertOpen,
	isProgressOpen: state.alert.isProgressOpen,
	bagCount: state.bag.totalQuantity,
});

const mapDispatchToProps = (dispatch) => ({
	openBag: () => dispatch(openBag()),
	initCart: () => dispatch(initCart()),
	handleAlertClose: () => dispatch(handleAlertClose()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
